import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';
import { router } from 'expo-router';

export function SignInPrompt({
  title,
  body,
  compact = false,
}: {
  title: string;
  body: string;
  compact?: boolean;
}) {
  return (
    <Card className={cn('mx-5 gap-0 py-0', compact && 'mx-0')}>
      <CardHeader className={cn('px-5 pt-5', compact && 'px-4 pt-4')}>
        <CardTitle className={cn('text-xl font-semibold', compact && 'text-lg')}>
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className={cn('px-5 pb-5 pt-3', compact && 'px-4 pb-4 pt-2')}>
        <Text variant="muted" className={cn('leading-6', compact && 'text-sm leading-6')}>
          {body}
        </Text>
      </CardContent>
      <Button
        className={cn('mx-5 mb-5 items-center justify-center', compact && 'mx-4 mb-4 min-h-11')}
        onPress={() => router.push('/sign-in')}>
        <Text className="font-semibold">Sign in</Text>
      </Button>
    </Card>
  );
}
